import React from "react";
import './src/scss/global.scss'
import { Provider as CommonProvider } from "./src/context/common"

export const wrapRootElement = ({ element }) => {
    return(
        <CommonProvider>
            { element }
        </CommonProvider>
    )
}
